import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CoachService } from 'src/app/core/services/coach_services/coach.service';
import { CoacheeService } from 'src/app/core/services/coachee_services/coachee.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})


export class SidebarComponent implements OnInit {
  isCoach: string;
  isCoachee: string;
  language: string = 'english';
  sidebarLogo: string;
  isAnalyticsEnabled: number;
  currentJourneyIsCompleted: boolean | null = null;

  constructor(
    public _cookiesService: CookieService,
    private _coacheeService: CoacheeService,
    private _coachService: CoachService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this._coachService.currentJourneyStatus$.subscribe(status => {
      this.currentJourneyIsCompleted = status;
    });
    this.isCoach = sessionStorage.getItem('isCoach');
    this.isCoachee = sessionStorage.getItem('isCoachee');

    if (this._cookiesService.check('lang')) {
      let browserLang = this._cookiesService.get('lang');
      this.language = browserLang == 'en' ? 'english' : 'german';
    }

    if (this.isCoachee === 'true') {
      this._coacheeService.getSidebarLogo().subscribe(data => {
        this.sidebarLogo = data;
      });
    } else {
      this.sidebarLogo = null;
      this._coachService.getAnalyticsConfiguration().subscribe(
        data => {
          this.isAnalyticsEnabled = data.enabled;
        },
        error => {
          console.error('Error making an API request', error);
        }
      );
    }
  }

  isJourneyLinkActive(type: 'current' | 'history'): boolean {
    const url = this.router.url;
    // Check if we are on the specific list page
    if (type === 'current' && url.includes('/coach-pages/coach-landing-page')) return true;
    if (type === 'history' && url.includes('/coach-pages/coaching-history')) return true;

    // Check if we are on a detail page and the status matches
    if (url.includes('/journey/')) {
      if (type === 'current' && this.currentJourneyIsCompleted === false) return true;
      if (type === 'history' && this.currentJourneyIsCompleted === true) return true;
    }

    return false;
  }
}
